module.exports = __webpack_public_path__ + "static/CSF2-e38170d11c8476716a0c780d6da84586.png";